module.exports = __webpack_public_path__ + "img/val-icon-5.00ed7846.svg";